module.exports = __webpack_public_path__ + "static/media/33.518ea1da.jpg";